import styled from 'styled-components';
import mainColors from '../../../../Style-guide/main-colors';
import sizeStandards from '../../../../Style-guide/size-standards';

const CourtInputsWrapper = styled.section`
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 40px;

  .inputs-column {
    max-width: 300px;
    width: 100%;
  }

  .numbers-column {
    margin-bottom: 20px;
  }

  .court-input {
    /* max-width: 300px; */
    width: 100%;
    margin: 24px 8px;

    &:first-child {
      margin-top: 0;
    }

    textarea {
      border: 2px solid ${mainColors.main_color};
    }
  }

  @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
    flex-direction: column;
    align-items: center;

    .court-input {
      max-width: 400px;
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;

export default CourtInputsWrapper;
